import Calendar1 from "@/assets/icons/Calendar1";
import { AspirationResponse } from "@/components/parts/admin/aspiration/interface";
import FieldValue from "@/components/shared/review/fieldValue";
import { Button } from "@/components/ui/button";
import { formatDateDay, getStatusText, getStatusTextColor } from "@/lib/utils";
import Link from "next/link";
import React from "react";

const AspirationCard = ({ item }: { item: AspirationResponse }) => {
  return (
    <div className="bg-white border rounded-lg p-6 space-y-4 shadow-md">
      <div className="space-y-2">
        <p className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-sm text-primary-700">
          <span className="flex items-center gap-2 font-medium">
            <Calendar1 />
            {formatDateDay(item.createdAt)}
          </span>
          <span className="rounded-full px-2 py-1 border border-primary-700 w-fit">
            {item.categoryAspiration?.name}
          </span>
        </p>
        <div className="space-y-3">
          <FieldValue label="Judul Pengajuan" labelClassName="mb-0">
            {item?.proposal}
          </FieldValue>
          <FieldValue label="Nama Masyarakat" labelClassName="mb-0">
            {item?.name}
          </FieldValue>
          <FieldValue
            label="Status"
            labelClassName="mb-0"
            valueClassName={getStatusTextColor(item.status)}
          >
            {getStatusText(item.status)}
          </FieldValue>
        </div>
      </div>

      <div className="flex justify-end">
        <Link href={`/aspiration/detail/${item.id}`}>
          <Button className="rounded-full bg-primary-700">Lihat Detail</Button>
        </Link>
      </div>
    </div>
  );
};

export default AspirationCard;
